// extracted by mini-css-extract-plugin
module.exports = {"try-module":"Try_try-module__2P6Im","love-tree":"Try_love-tree__2Usut"};